module.exports = __webpack_public_path__ + "1280px-Google_Play_Store_badge_EN1.svg?a057f8bc13b2fbad64d3106e18ab137f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1280px-Google_Play_Store_badge_EN1.svg
// module id = 99
// module chunks = 0